import React from 'react';
import { Box, Button, Heading, Image, List, ListItem, ListIcon, Text } from '@chakra-ui/react';
import { MdCheckCircle } from 'react-icons/md';
import { Link as RouterLink } from 'react-router-dom';

export default function ServiceCard({
  service, onOpen, showHighlights = false, ctaTo = '/services', ctaLabel = 'Ver servicio',
}) {
  return (
    <Box
      display="flex"
      flexDirection="column"
      h="100%"
      minW={0}
      bg="surface.default"
      borderRadius="lg"
      border="1px solid"
      borderColor="border.default"
      overflow="hidden"
      boxShadow="sm"
      transitionDuration="200ms"
      _hover={{ boxShadow: 'md', transform: 'translateY(-2px)' }}
    >
      <Image
        src={service.image}
        alt={service.imageAlt || service.title}
        w="100%"
        aspectRatio={16 / 10}
        objectFit="cover"
        loading="lazy"
        decoding="async"
      />
      <Box p={{ base: 4, sm: 5 }} display="flex" flexDirection="column" flexGrow={1} minW={0}>
        <Heading as="h3" fontSize={{ base: 'md', md: 'lg' }} fontWeight={700} mb={2} lineHeight={1.3}>
          {service.shortTitle || service.title}
        </Heading>
        <Text fontSize="sm" color="text.secondary" mb={3} flexShrink={0}>
          {service.summary}
        </Text>

        {showHighlights && service.highlights && (
          <List spacing={2} mb={4} fontSize="xs" color="text.primary">
            {service.highlights.map((item, idx) => (
              <ListItem key={idx} display="flex" alignItems="flex-start">
                <ListIcon as={MdCheckCircle} color="brand.600" boxSize={4} mt="2px" flexShrink={0} />
                <Text as="span">{item}</Text>
              </ListItem>
            ))}
          </List>
        )}

        <Box mt="auto" pt={2} minW={0}>
          {onOpen ? (
            <Button
              variant="secondary"
              size="sm"
              w="100%"
              onClick={() => onOpen(service)}
              whiteSpace="normal"
              textAlign="center"
              aria-label={`Ver ${service.title}`}
            >
              {ctaLabel}
            </Button>
          ) : (
            <Button
              as={RouterLink}
              to={ctaTo}
              variant="secondary"
              size="sm"
              w="100%"
              whiteSpace="normal"
              textAlign="center"
              aria-label={`Ver ${service.title}`}
            >
              {ctaLabel}
            </Button>
          )}
        </Box>
      </Box>
    </Box>
  );
}
